var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronTeal = function SvgChevronTeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17813 0.839593C2.45109 0.164613 1.27232 0.164613 0.545282 0.839593C-0.181759 1.51457 -0.181759 2.60893 0.545282 3.28391L11.1836 13.1605C11.9106 13.8354 13.0894 13.8354 13.8164 13.1605L24.4547 3.28391C25.1818 2.60893 25.1818 1.51457 24.4547 0.839593C23.7277 0.164613 22.5489 0.164613 21.8219 0.839593L12.4949 9.4987L3.17813 0.839593Z",
    fill: "#a2bc3a"
  })));
};
export default SvgChevronTeal;